/**
 * The sole purpose of this object is to store the transition direction (slide for slide in or slide_out for back navigation) in a non-reactive way
 * Reason: The transitionName is set within the router/index beforeEach hook. However the mutation of theis variable should not trigger a rerender because that is already triggered by the page navigation.
 */
export default {
    transitionName:''
}